// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3f8O7Drj","hidden":"_5rDZnzOb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.pcss
// module id = 372
// module chunks = 0